import { useState, useEffect } from 'react'
import moment from 'moment-timezone'

export const useCurrentTime = (timezone = moment.tz.guess()) => {
  const [currentTime, setCurrentTime] = useState(new Date())

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date())
    }, 1000)

    return () => {
      clearInterval(interval)
    }
  }, [])

  const formattedTime = timezone
    ? moment(currentTime).tz(timezone).format('hh:mm a')
    : moment().format('hh:mm a')

  return formattedTime
}
